import '../../styles/pages/_design-system.scss';
document.querySelectorAll('.js-copy-html').forEach(button => {
    button.addEventListener('click', async () => {
        const nextSib = button.nextElementSibling;
        const html = nextSib.outerHTML.replace(nextSib.innerHTML || '', '').trim();
        try {
            await navigator.clipboard.writeText(html);
            const initialText = button.innerHTML;
            button.innerHTML = 'Copied!';
            setTimeout(() => {
                button.innerHTML = initialText;
            }, 2000);
        }
        catch (error) {
            console.error('Failed to copy HTML:', error);
        }
    });
});
const EYEBROW_SELECTOR = '.fluid-eyebrow-1, .fluid-eyebrow-2, .fluid-eyebrow-3, .fluid-eyebrow-4';
const HEADER_SELECTOR = '.fluid-h1, .fluid-h2, .fluid-h3, .fluid-h4';
const SUBCOPY_SELECTOR = '.fluid-subcopy-1, .fluid-subcopy-2, .fluid-subcopy-3, .fluid-subcopy-4';
const CTA_SELECTOR = '.fluid-cta';
const HIDDEN_CLASS = 'fluid-controls-hidden';
const DEFAULT_EYEBROW = 'Eyebrow';
const DEFAULT_HEADER = 'Fluid H1';
const DEFAULT_SUBCOPY = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's.";
const DEFAULT_CTA = 'Shop Now';
const CTA_CLASS_OPTIONS = [
    'button-primary-v2',
    'button-secondary-v2',
    'button-primary-v2--inverse',
    'button-secondary-v2--inverse',
    'button-primary-v2--outlined',
    'button-secondary-v2--outlined'
];
const DEFAULT_CTA_CLASS = 'button-primary-v2';
class DesignSystemFluidControls extends HTMLElement {
    state = {
        eyebrowText: DEFAULT_EYEBROW,
        headerText: DEFAULT_HEADER,
        subcopyText: DEFAULT_SUBCOPY,
        ctaText: DEFAULT_CTA,
        ctaClass: DEFAULT_CTA_CLASS,
        showEyebrow: true,
        showHeader: true,
        showSubcopy: true,
        showCta: true
    };
    boundSyncContainers = () => this.syncContainers();
    connectedCallback() {
        this.readInitialState();
        this.render();
        this.attachEventListeners();
        this.syncContainers();
    }
    disconnectedCallback() {
        this.removeEventListeners();
    }
    readInitialState() {
        const firstEyebrow = document.querySelector(`${EYEBROW_SELECTOR}`);
        const firstHeader = document.querySelector(`${HEADER_SELECTOR}`);
        const firstSubcopy = document.querySelector(`${SUBCOPY_SELECTOR}`);
        const firstCta = document.querySelector(CTA_SELECTOR);
        if (firstEyebrow?.textContent?.trim()) {
            this.state.eyebrowText = firstEyebrow.textContent.trim();
        }
        if (firstHeader?.textContent?.trim()) {
            this.state.headerText = firstHeader.textContent.trim();
        }
        if (firstSubcopy?.textContent?.trim()) {
            this.state.subcopyText = firstSubcopy.textContent.trim();
        }
        if (firstCta?.textContent?.trim()) {
            this.state.ctaText = firstCta.textContent.trim();
        }
        if (firstCta) {
            const existingClass = CTA_CLASS_OPTIONS.find(cls => firstCta.classList.contains(cls));
            if (existingClass) {
                this.state.ctaClass = existingClass;
            }
        }
    }
    getContainers() {
        return Array.from(document.querySelectorAll('.fluid-container.fluid-container--block'));
    }
    syncContainers() {
        this.getContainers().forEach(container => {
            container.querySelectorAll(EYEBROW_SELECTOR).forEach(el => {
                el.textContent = this.state.eyebrowText;
                el.classList.toggle(HIDDEN_CLASS, !this.state.showEyebrow);
            });
            container.querySelectorAll(HEADER_SELECTOR).forEach(el => {
                el.textContent = this.state.headerText;
                el.classList.toggle(HIDDEN_CLASS, !this.state.showHeader);
            });
            container.querySelectorAll(SUBCOPY_SELECTOR).forEach(el => {
                el.textContent = this.state.subcopyText;
                el.classList.toggle(HIDDEN_CLASS, !this.state.showSubcopy);
            });
            container.querySelectorAll(CTA_SELECTOR).forEach(el => {
                el.textContent = this.state.ctaText;
                el.classList.toggle(HIDDEN_CLASS, !this.state.showCta);
                CTA_CLASS_OPTIONS.forEach(cls => el.classList.remove(cls));
                el.classList.add(this.state.ctaClass);
            });
        });
    }
    render() {
        this.innerHTML = `
      <div class="design-system-fluid-controls">
        <h3 class="design-system-fluid-controls__title">Fluid container copy</h3>
        <div class="design-system-fluid-controls__row">
          <label class="design-system-fluid-controls__label">Eyebrow</label>
          <input
            type="text"
            class="design-system-fluid-controls__input"
            id="fluid-controls-eyebrow"
            value="${this.escapeHtml(this.state.eyebrowText)}"
            aria-label="Eyebrow text"
          />
          <label class="design-system-fluid-controls__checkbox-label">
            <input
              type="checkbox"
              class="design-system-fluid-controls__checkbox"
              id="fluid-controls-show-eyebrow"
              ${this.state.showEyebrow ? 'checked' : ''}
              aria-label="Show eyebrow"
            />
            Show
          </label>
        </div>
        <div class="design-system-fluid-controls__row">
          <label class="design-system-fluid-controls__label">Header</label>
          <input
            type="text"
            class="design-system-fluid-controls__input"
            id="fluid-controls-header"
            value="${this.escapeHtml(this.state.headerText)}"
            aria-label="Header text"
          />
          <label class="design-system-fluid-controls__checkbox-label">
            <input
              type="checkbox"
              class="design-system-fluid-controls__checkbox"
              id="fluid-controls-show-header"
              ${this.state.showHeader ? 'checked' : ''}
              aria-label="Show header"
            />
            Show
          </label>
        </div>
        <div class="design-system-fluid-controls__row">
          <label class="design-system-fluid-controls__label">Subcopy</label>
          <input
            type="text"
            class="design-system-fluid-controls__input"
            id="fluid-controls-subcopy"
            value="${this.escapeHtml(this.state.subcopyText)}"
            aria-label="Subcopy text"
          />
          <label class="design-system-fluid-controls__checkbox-label">
            <input
              type="checkbox"
              class="design-system-fluid-controls__checkbox"
              id="fluid-controls-show-subcopy"
              ${this.state.showSubcopy ? 'checked' : ''}
              aria-label="Show subcopy"
            />
            Show
          </label>
        </div>
        <div class="design-system-fluid-controls__row">
          <label class="design-system-fluid-controls__label">CTA</label>
          <input
            type="text"
            class="design-system-fluid-controls__input"
            id="fluid-controls-cta"
            value="${this.escapeHtml(this.state.ctaText)}"
            aria-label="CTA text"
          />
          <label class="design-system-fluid-controls__label design-system-fluid-controls__label--style">Style</label>
          <select
            class="design-system-fluid-controls__select"
            id="fluid-controls-cta-style"
            aria-label="CTA style"
          >
            ${CTA_CLASS_OPTIONS.map(cls => `<option value="${this.escapeHtml(cls)}" ${this.state.ctaClass === cls ? 'selected' : ''}>${this.escapeHtml(cls)}</option>`).join('')}
          </select>
          <label class="design-system-fluid-controls__checkbox-label">
            <input
              type="checkbox"
              class="design-system-fluid-controls__checkbox"
              id="fluid-controls-show-cta"
              ${this.state.showCta ? 'checked' : ''}
              aria-label="Show CTA"
            />
            Show
          </label>
        </div>
      </div>
    `;
    }
    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
    attachEventListeners() {
        const eyebrowInput = this.querySelector('#fluid-controls-eyebrow');
        const headerInput = this.querySelector('#fluid-controls-header');
        const subcopyInput = this.querySelector('#fluid-controls-subcopy');
        const ctaInput = this.querySelector('#fluid-controls-cta');
        const showEyebrowCheckbox = this.querySelector('#fluid-controls-show-eyebrow');
        const showHeaderCheckbox = this.querySelector('#fluid-controls-show-header');
        const showSubcopyCheckbox = this.querySelector('#fluid-controls-show-subcopy');
        const showCtaCheckbox = this.querySelector('#fluid-controls-show-cta');
        const ctaStyleSelect = this.querySelector('#fluid-controls-cta-style');
        eyebrowInput?.addEventListener('input', () => {
            this.state.eyebrowText = eyebrowInput.value;
            this.boundSyncContainers();
        });
        headerInput?.addEventListener('input', () => {
            this.state.headerText = headerInput.value;
            this.boundSyncContainers();
        });
        subcopyInput?.addEventListener('input', () => {
            this.state.subcopyText = subcopyInput.value;
            this.boundSyncContainers();
        });
        ctaInput?.addEventListener('input', () => {
            this.state.ctaText = ctaInput.value;
            this.boundSyncContainers();
        });
        ctaStyleSelect?.addEventListener('change', () => {
            this.state.ctaClass = ctaStyleSelect.value;
            this.boundSyncContainers();
        });
        showEyebrowCheckbox?.addEventListener('change', () => {
            this.state.showEyebrow = showEyebrowCheckbox.checked;
            this.boundSyncContainers();
        });
        showHeaderCheckbox?.addEventListener('change', () => {
            this.state.showHeader = showHeaderCheckbox.checked;
            this.boundSyncContainers();
        });
        showSubcopyCheckbox?.addEventListener('change', () => {
            this.state.showSubcopy = showSubcopyCheckbox.checked;
            this.boundSyncContainers();
        });
        showCtaCheckbox?.addEventListener('change', () => {
            this.state.showCta = showCtaCheckbox.checked;
            this.boundSyncContainers();
        });
    }
    removeEventListeners() {
        // Inputs and checkboxes are replaced when innerHTML is set; no persistent refs to remove.
    }
}
if (!window.customElements.get('design-system-fluid-controls')) {
    customElements.define('design-system-fluid-controls', DesignSystemFluidControls);
}
